
import React from 'react';
import styled from '@emotion/styled';

import { mq } from '../../_style';

import Image from './image';

export default class ArticleImage extends React.Component {
  render() {
    const Img = styled.figure`
      ${mq.pc} {
        ${this.props.onlySp && 'display: none;'}
      }
      ${mq.sp} {
        ${this.props.onlyPc && 'display: none;'}
      }
    `
    return(
      <Img>
        <Image filename={this.props.filename} alt=""></Image>
      </Img>
    )
  }
}
